import { AuthProvider } from "./context/auth.context";
import { AuthRefresher } from "./components/AuthRefresher";
import { PinGate } from "./components/PinGate/PinGate";

export const AuthRoot: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <AuthProvider>
    <AuthRefresher>
      <PinGate>{children}</PinGate>
    </AuthRefresher>
  </AuthProvider>
)
